import * as React from 'react'
import { SVGProps } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}

const RoundedArrowUpIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={20}
    height={20}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <circle
      cx={10}
      cy={10}
      r={10}
      transform="rotate(90 10 10)"
      fill="#F2F5F2"
      fillOpacity={0.6}
    />
    <path
      d="m6.465 10 3.546-3.534L13.534 10l-.679.7-2.36-2.349v5.194h-.98V8.351l-2.35 2.35-.7-.7Z"
      fill="#414141"
    />
  </svg>
)

export default RoundedArrowUpIcon
